import { PanelType } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import {
  IconButton,
  iconButtonStylesNoBG,
  IPanelProps,
  PageHeader,
  pageHeaderStylesSecondary,
  Panel,
  useClassNames,
} from '@h2oai/ui-kit';
import { useEffect } from 'react';

import { Project } from '../../featurestore/gen/ai/h2o/featurestore/api/v1/CoreService.pb';
import { ContentsTitle, narrowPanelWidth } from '../../featurestore/models';
import { CreateUpdateProject } from '../CreateUpdateProject/CreateUpdateProject';
import { IProjectPanelClassNames, IProjectPanelStyles, projectPanelStylesDefault } from './ProjectPanel.styles';

export type ProjectPanelProps = {
  show?: boolean;
  onDismiss: (project?: Project, deleted?: boolean) => void;
  data?: Project;
};

export const ProjectPanel = ({ show, onDismiss, data }: ProjectPanelProps) => {
  const [isOpen, { setTrue: open, setFalse: close }] = useBoolean(false);
  const panelProps: IPanelProps = {
    type: PanelType.custom,
    customWidth: narrowPanelWidth,
    isOpen,
    onDismiss: () => onDismiss(),
    isFooterAtBottom: true,
    hasCloseButton: false,
  };

  useEffect(() => {
    if (show) {
      open();
    } else {
      close();
    }
  }, [show]);
  const classNames = useClassNames<IProjectPanelStyles, IProjectPanelClassNames>(
    'ProjectPanel',
    projectPanelStylesDefault
  );
  const title = data ? ContentsTitle.editProject : ContentsTitle.createProject,
    projectName = data?.name,
    parentBreadcrumb = projectName || ContentsTitle.project,
    childBreadcrumb = projectName ? ContentsTitle.editProject : title;
  return (
    <Panel {...panelProps}>
      <div className={classNames.root}>
        <PageHeader
          pageTitle={title}
          styles={pageHeaderStylesSecondary}
          breadcrumbProps={{
            items: [
              {
                text: parentBreadcrumb,
                key: parentBreadcrumb,
                onClick: projectName ? undefined : () => onDismiss(),
              },
              {
                text: childBreadcrumb,
                key: childBreadcrumb,
                isCurrentItem: true,
              },
            ],
          }}
          actions={<IconButton styles={iconButtonStylesNoBG} iconName="Clear" onClick={() => onDismiss()} />}
        ></PageHeader>
        <CreateUpdateProject
          onUpdate={(project, deleted) => onDismiss(project, deleted)}
          onCancel={() => onDismiss()}
          project={data}
        />
      </div>
    </Panel>
  );
};
